import { createElementFromHTML } from "./helpers";
import ImagesLoaded from "imagesloaded";

export default function(){
    let
        method = {},
        $overlay,
        $modal,
        $content,
        $close;

    // Center the modal in the viewport
    method.center = function () {
        let top, left, domRect, scrollTop, scrollLeft;

        $modal.style.top = "0px";
        $modal.style.left = "0px";

        domRect = $modal.getBoundingClientRect()

        top = Math.max(window.outerHeight - domRect.height, 0) / 2;
        left = Math.max(document.body.clientWidth - domRect.width, 0) / 2;

        scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        scrollLeft =  window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;

        $modal.style.top = (top + scrollTop) + "px";
        $modal.style.left = (left + scrollLeft) + "px";
    };

    // Open the modal
    method.open = function (settings) {
        $content.innerHTML = settings.content;

        $modal.style.width = settings.width || 'auto';
        $modal.style.height = settings.height || 'auto';

        method.center();

        window.addEventListener('resize', method.center);
        $modal.classList.add("visible");
        $overlay.classList.add("visible");

        new ImagesLoaded($content, function () {
            method.center();
        })
    };

    method.setContent = function (content) {
        $content.innerHTML = content;

        method.center();
    };

    // Close the modal
    method.close = function () {
        $modal.dispatchEvent(new Event('cerrando'));
        $modal.classList.remove("visible");
        $overlay.classList.remove("visible");
        $content.innerHTML = "";
        window.removeEventListener("resize", method.center);
    };

    // Generate the HTML and add it to the document

    $overlay = createElementFromHTML('<div class="overlay"></div>');
    $modal = createElementFromHTML('<div class="modal"></div>');
    $content = createElementFromHTML('<div class="content"></div>');

    $close = createElementFromHTML('<div class="close">\n' +
        '        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '            <path d="M21 1.8375L19.1625 0L10.5 8.6625L1.8375 0L0 1.8375L8.6625 10.5L0 19.1625L1.8375 21L10.5 12.3375L19.1625 21L21 19.1625L12.3375 10.5L21 1.8375Z" fill="black"/>\n' +
        '        </svg>\n' +
        '    </div>');


    $modal.append($content);
    $modal.append($close);

    document.addEventListener("DOMContentLoaded", function(event) {
        let $overLayAnterior = document.querySelector(".overlay");
        if ($overLayAnterior) {
            $overlay = $overLayAnterior;
        } else {
            document.body.append(($overlay))
        }

        $overlay.addEventListener("click", method.close)

        let $modalAnterior = document.querySelector(".modal");
        if ($modalAnterior) {
            $modal = $modalAnterior;
            $content = $modal.querySelector(".content");
        } else {
            document.body.append(($modal))
        }

        $close.addEventListener("click", method.close)

    });

    return method;
};
